// extracted by mini-css-extract-plugin
export default {"bg":"herobanner_bg__CuFYv"};